import { r as f, D as s, g as _, u as v } from "./resources-DFDnbwuT.mjs";
var o = /* @__PURE__ */ function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, a) {
      r.__proto__ = a;
    } || function(r, a) {
      for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && (r[u] = a[u]);
    }, t(e, n);
  };
  return function(e, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), O = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.createGauge = function(e, n) {
      return h;
    }, t.prototype.createHistogram = function(e, n) {
      return P;
    }, t.prototype.createCounter = function(e, n) {
      return m;
    }, t.prototype.createUpDownCounter = function(e, n) {
      return d;
    }, t.prototype.createObservableGauge = function(e, n) {
      return R;
    }, t.prototype.createObservableCounter = function(e, n) {
      return w;
    }, t.prototype.createObservableUpDownCounter = function(e, n) {
      return G;
    }, t.prototype.addBatchObservableCallback = function(e, n) {
    }, t.prototype.removeBatchObservableCallback = function(e) {
    }, t;
  }()
), i = (
  /** @class */
  /* @__PURE__ */ function() {
    function t() {
    }
    return t;
  }()
), M = (
  /** @class */
  function(t) {
    o(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.prototype.add = function(n, r) {
    }, e;
  }(i)
), b = (
  /** @class */
  function(t) {
    o(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.prototype.add = function(n, r) {
    }, e;
  }(i)
), N = (
  /** @class */
  function(t) {
    o(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.prototype.record = function(n, r) {
    }, e;
  }(i)
), y = (
  /** @class */
  function(t) {
    o(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.prototype.record = function(n, r) {
    }, e;
  }(i)
), p = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.addCallback = function(e) {
    }, t.prototype.removeCallback = function(e) {
    }, t;
  }()
), g = (
  /** @class */
  function(t) {
    o(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e;
  }(p)
), C = (
  /** @class */
  function(t) {
    o(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e;
  }(p)
), E = (
  /** @class */
  function(t) {
    o(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e;
  }(p)
), l = new O(), m = new M(), h = new N(), P = new y(), d = new b(), w = new g(), R = new C(), G = new E();
function D() {
  return l;
}
var I = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.getMeter = function(e, n, r) {
      return l;
    }, t;
  }()
), T = new I(), c = "metrics", U = (
  /** @class */
  function() {
    function t() {
    }
    return t.getInstance = function() {
      return this._instance || (this._instance = new t()), this._instance;
    }, t.prototype.setGlobalMeterProvider = function(e) {
      return f(c, e, s.instance());
    }, t.prototype.getMeterProvider = function() {
      return _(c) || T;
    }, t.prototype.getMeter = function(e, n, r) {
      return this.getMeterProvider().getMeter(e, n, r);
    }, t.prototype.disable = function() {
      v(c, s.instance());
    }, t;
  }()
), k = U.getInstance();
export {
  D as c,
  k as m
};
